import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import { GoogleTagManagerService } from '../../analytics/google-tag-manager.service';
import { GeolocationService } from '../geolocation/geolocation.service';
import { GeolocationInfo } from '../../models/geolocation';
import { isPlatformBrowser } from '@angular/common';
import {LegacyLoginService} from "../../../shared/services/legacy-login.service";

@Injectable({
  providedIn: 'root'
})

export class ApplicationInitializeService {

  private isNotOnBrowser: boolean;

  get isSafariBrowser() {
    const userAgentDescription = window.navigator.userAgent.toLowerCase();
    return userAgentDescription.includes('safari') && !userAgentDescription.includes('chrome');
  }

  get isLastGeolocationAllowanceStillValid() {
    const storedDate = new Date(localStorage.getItem('lps-geolocation-accepted-safari'));
    return storedDate.getTime() > new Date(Date.now() - 604800000).getTime();
  }

  public constructor(
    private readonly googleTagManagerService: GoogleTagManagerService,
    private readonly geolocationService: GeolocationService,
    private readonly legacyLoginService: LegacyLoginService,
    @Inject(PLATFORM_ID) private readonly platformId: string,
    ) {
    this.isNotOnBrowser = !isPlatformBrowser(this.platformId);
  }

  public initialize(): void {
    this.googleTagManagerService.initialize();
    this.legacyLoginService.autologin();
    this.getCurrentLocationAndSave();
  }

  // -------- GEO LOCATION --------

  private getCurrentLocationAndSave() {
    if (this.isLastGeolocationAllowanceStillValid) {
      return;
    }
    this.getCurrentLocation()
      .then(location => this.saveCookies(location))
      .catch(error => console.log(error.message))
      .finally(() => this.saveGeolocationAcceptance());
  }

  public getCurrentLocation(): Promise<any> {
    const resolverCookies = (resolve, reject) => {
      if (this.isNotOnBrowser) {
        return reject(new Error('Cannot get location on server.'));
      }
      window.navigator.geolocation.getCurrentPosition((position) => {
          const latitude = position.coords.latitude.toString();
          const longitude = position.coords.longitude.toString();
          resolve(new GeolocationInfo(latitude, longitude));
        }, (e) => reject(e),
      );
    };
    return new Promise<GeolocationInfo>(resolverCookies);
  }

  private saveCookies(location: GeolocationInfo): void {
    this.geolocationService.setSubjectGeolocationInfo(location);
    this.geolocationService.saveLocationOnCookies(location);
  }

  private saveGeolocationAcceptance() {
    if (this.isSafariBrowser) {
      localStorage.setItem('lps-geolocation-accepted-safari', new Date().toLocaleString());
    }
  }
}
